/** Format therapist list for display in modals and notices. */
export const formatTherapistsDisplay = (therapists, fallbackTherapist = '') => {
  if (Array.isArray(therapists) && therapists.length > 0) {
    return therapists
      .map((entry) => {
        const name = typeof entry === 'string' ? entry : entry?.name;
        if (!name) return null;
        const isPrimary = typeof entry === 'object' && entry.is_primary;
        return isPrimary ? `${name} (primary)` : name;
      })
      .filter(Boolean)
      .join(', ');
  }
  return fallbackTherapist || '';
};

export const primaryTherapistName = (therapists, fallback = '') => {
  if (!Array.isArray(therapists) || therapists.length === 0) return fallback;
  const primary = therapists.find((t) => t.is_primary) || therapists[0];
  if (typeof primary === 'string') return primary;
  return primary?.name || fallback;
};

export const therapistNamesFromList = (therapists) => {
  if (!Array.isArray(therapists)) return [];
  return therapists
    .map((entry) => (typeof entry === 'string' ? entry : entry?.name))
    .filter(Boolean);
};

/** Compact desk label, e.g. "Chingboi +(1)" for multi-therapist bookings. */
export const formatCompactTherapistDisplay = (booking) => {
  const therapists = booking?.therapists || [];
  const therapistsCount = booking?.therapistsCount
    || (therapists.length > 0 ? therapists.length : 0)
    || (booking?.therapist ? 1 : 0);
  if (therapistsCount <= 1 || therapists.length === 0) {
    return booking?.therapist || booking?.therapist_name || '';
  }
  const primary = therapists.find((t) => t.is_primary) || therapists[0];
  const primaryName = primary?.name || booking?.therapist || '';
  const firstName = primaryName.split(' ')[0];
  return `${firstName} +(${therapistsCount - 1})`;
};

/** Full therapist list for chip tooltip / accessibility. */
export const getTherapistDisplayTitle = (booking) => {
  const therapists = booking?.therapists || [];
  if (therapists.length > 1) {
    return therapists.map((t) => (typeof t === 'string' ? t : t.name)).filter(Boolean).join(', ');
  }
  return booking?.therapist || booking?.therapist_name || '';
};

export const resolveTherapistsForConfirm = ({
  formTherapists = [],
  previewTherapists = [],
  fallbackTherapist = '',
  therapistsRequired = 1,
}) => {
  const required = Math.max(1, therapistsRequired || 1);
  if (formTherapists.length >= required) {
    return formTherapists;
  }
  if (previewTherapists.length > 0) {
    return previewTherapists;
  }
  if (fallbackTherapist) {
    return [{ name: fallbackTherapist, is_primary: true }];
  }
  return [];
};
